module.exports = __webpack_public_path__ + "static/media/step4@2x.dbf32e60.mov";